"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var rxjs_1 = require("rxjs");

var operators_1 = require("rxjs/operators");

var util_1 = require("../../messages/util");

var observable_client_1 = __importDefault(require("../../observable-client"));
/**
 * Node socket error code
 */


var ERROR_CODE_ECONNRESET = 'ECONNRESET';
/**
 * Chrome OS error message (no code given)
 */

var CHROME_OS_ECONNRESET = /The connection was closed/i;

var isConnectionResetError = function isConnectionResetError(error) {
  return 'code' in error && error.code === ERROR_CODE_ECONNRESET || CHROME_OS_ECONNRESET.test(error.message);
};

var Request =
/** @class */
function () {
  function Request(host, port, parseResponse) {
    this.host = host;
    this.port = port;
    this.client = new observable_client_1.default(host, port).pipe( // tender retail resets the connection
    // when we're done talking. this makes the socket
    // angry, so we need to check for and catch this
    // error
    operators_1.catchError(function (error) {
      if (isConnectionResetError(error)) {
        return rxjs_1.empty();
      }

      return rxjs_1.throwError(error);
    }), util_1.parseDataUsingFunction(parseResponse));
  }

  Request.prototype.pipe = function () {
    var _a;

    var operators = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      operators[_i] = arguments[_i];
    }

    this.client = (_a = this.client).pipe.apply(_a, operators);
    return this;
  };
  /**
   * create a subscription to the internal client
   * @param {Observer<T>} observer an observer object that
   * with complete, next, error methods for handling the
   * connection stream
   *
   * @returns {@import('rxjs').Subscription} an object with an
   * unsubscribe function, for cleaning up subscription
   */


  Request.prototype.subscribe = function (observer) {
    return this.client.subscribe(observer);
  };
  /**
   * initializes the connection to tender retail. must be
   * called before writing messages
   *
   * @returns {Promise<void>}
   */


  Request.prototype.connect = function () {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , this.client.connect()];

          case 1:
            _a.sent();

            return [2
            /*return*/
            ];
        }
      });
    });
  };
  /**
   * writes a buffer to the client
   *
   * @param {Buffer} data the data to send to the socket connection
   *
   * @returns {Promise<void>}
   */


  Request.prototype.writeBuffer = function (data) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , this.client.write(data)];

          case 1:
            _a.sent();

            return [2
            /*return*/
            ];
        }
      });
    });
  };

  return Request;
}();

exports.Request = Request;